import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { Events } from '../core/events'
import { StickyHeader } from '../modules/sticky-header.js'
import { gsap } from 'gsap'
import debounce from 'lodash/debounce'
import throttle from 'lodash/throttle'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

/** Overlay menu
 *
 */
class OverlayMenu {
	constructor(el, options) {
		this.element = el
		this.overlayVisible = false

		this.options = Object.assign({}, options)

		if (this.options.elOpenOverlay) {
			this.elOpenOverlay = this.options.elOpenOverlay
		}

		if (this.options.elCloseOverlay) {
			this.elCloseOverlay = this.options.elCloseOverlay
		}

		this.elOverlayPrimary = this.elPanel.querySelector('.island-overlay__primary-nav')
		this.elNavItems = Array.from(this.elOverlayPrimary.querySelectorAll('.island-overlay__primary-nav .nav-item'))
		this.elOverlaySecondary = this.elPanel.querySelector('.island-overlay__secondary-nav')

		this.elLanguage = document.body.querySelector('.header__language')
		this.isVisible = false

		this.boundShowOverlay = this.show.bind(this)
		this.boundHideOverlay = this.hide.bind(this)
		this.boundToggleOverlay = this.toggle.bind(this)

		if (this.elOpenOverlay === this.elCloseOverlay) {
			this.elOpenOverlay.addEventListener('click', this.boundToggleOverlay)
		} else {
			this.elOpenOverlay.addEventListener('click', this.boundShowOverlay)
			this.elCloseOverlay.addEventListener('click', this.boundHideOverlay)
		}

		this.bndOnPanelLinkClick = this.onPanelLinkClick.bind(this)
		this.elPanel.addEventListener('click', this.bndOnPanelLinkClick)
	}

	toggle(e) {
		if (this.isVisible) {
			this.hide(e)
		} else {
			this.show(e)
		}
	}

	show(e) {
		window.alert('show')
		if (this.isVisible) return

		if (e) {
			e.preventDefault()
			e.stopPropagation()
		}

		this.isVisible = true

		if (this.transition) {
			this.transition.kill()
		}

		if (this.options.onToggle) {
			this.options.onToggle(true)
		}
		this.element.classList.add('is-expanded')

		//
		// 		this.elOverlayPrimary = this.elPanel.querySelector('.island-overlay__primary-nav')
		// this.elNavItems = Array.from(this.elOverlayPrimary.querySelectorAll('.island-overlay__primary-nav .nav-item'))
		// this.elOverlaySecondary = this.elPanel.querySelector('.island-overlay__secondary-nav')

		gsap.set([this.elOverlayPrimary, this.elOverlaySecondary], {
			opacity: 0,
		})

		gsap.fromTo(
			[this.elOverlayPrimary, this.elOverlaySecondary],
			{ autoAlpha: 0, y: 20 },
			{
				autoAlpha: 1,
				y: 0,
				duration: 0.8,
				ease: 'Power2.easeOut',
				stagger: 0.5,
			},
		)

		// gsap.set(this.element, {
		// 	pointerEvents: 'all',
		// 	display: 'block',
		// 	opacity: 0,
		// })

		// this.transition = gsap.timeline()
		// this.transition.to(this.element, {
		// 	// x: '0%',
		// 	opacity: 1,
		// 	duration: 0.5,
		// 	ease: 'Power3.easeOut',
		// 	onComplete: () => {
		// 		window.app.browser.disableScroll(this.element)
		// 	},
		// })
	}
	hide(e) {
		if (!this.isVisible) return
		if (e) {
			e.preventDefault()
			e.stopPropagation()
		}
		this.isVisible = false

		if (this.transition) {
			this.transition.kill()
		}
		if (this.options.onToggle) {
			this.options.onToggle(false)
		}

		// transition
		// window.app.browser.enableScroll(this.element)
		// gsap.set(this.element, { pointerEvents: 'none' })
		// this.transition = gsap.timeline({})
		// this.transition.to(this.element, {
		// 	// x: '-120%',
		// 	opacity: 0,
		// 	duration: 0.5,
		// 	ease: 'Power3.easeOut',
		// 	onComplete: () => {
		// 		gsap.set(this.element, { display: 'none' })
		this.element.classList.remove('is-expanded')
		// 	},
		// })
	}
	onPanelClick(e) {
		// Check if the clicked element is a link or within a link
		const link = e.target.closest('a')

		if (link && link.href) {
			// Optional: Add a small delay to allow for visual feedback
			//setTimeout(() => {
			this.hide()
			//}, 100)
		}
	}
	destroy() {
		if (this.elOpenOverlay === this.elCloseOverlay) {
			this.elOpenOverlay.removeEventListener('click', this.boundToggleOverlay)
		} else {
			this.elOpenOverlay.removeEventListener('click', this.boundShowOverlay)
			this.elCloseOverlay.removeEventListener('click', this.boundHideOverlay)
		}
		window.app.browser.enableScroll(this.element)

		this.elPanel.removeEventListener('click', this.bndOnPanelLinkClick)
	}
}

class OverlayHandler {
	constructor(element) {
		this.elOverlay = element.querySelector('.js-nav-overlay')

		this.elToggleOverlay = element.querySelector('.nav-overlay__toggle')

		this.overlayMenu = new OverlayMenu(this.elOverlay, {
			elOpenOverlay: this.elToggleOverlay,
			elCloseOverlay: this.elToggleOverlay,
			onToggle: (state) => {
				// if (state) {
				// 	this.element.classList.add('has-overlay')
				// } else {
				// 	this.element.classList.remove('has-overlay')
				// }
			},
		})

		this.bndOnNavShapeClick = this.onNavShapeClick.bind(this)
		this.elOverlay.addEventListener('click', this.bndOnNavShapeClick)
	}

	hide() {
		this.overlayMenu.hide()
	}

	show() {
		this.overlayMenu.show()
	}

	onNavShapeClick(e) {
		if (this.overlayMenu.isVisible) return
		this.overlayMenu.show()
	}

	destroy() {
		this.overlayMenu.destroy()
		this.elOverlay.removeEventListener('click', this.bndOnNavShapeClick)
	}
}

class ProgressTracker {
	constructor(options) {
		this.options = {
			progressEndSelector: '[data-progress-end]',
			...options,
		}

		this.element = this.options.element
		this.elProgressBarTracker = this.options.elProgressTracker

		// Configure scroll element - default to window/document for browser scrollbar
		this.scrollElement = this.options.scrollElement || window
		this.scrollTarget = this.options.scrollElement || document.documentElement

		// Optional custom progress end target

		if (this.options.progressEndSelector) {
			this.progressEndEl = document.body.querySelector(this.options.progressEndSelector)
		}

		this.progressEndScrollTop = null
		this.bndOnScroll = throttle(this.onScroll.bind(this), 100)
		this.bndOnResize = throttle(this.updateProgressEndScrollTop.bind(this), 200)

		this.bndOnScroll = throttle(this.onScroll.bind(this), 100)

		this.element.classList.add('is-ready')
		this.setupScrollProgress()
	}

	setupScrollProgress() {
		gsap.set(this.elProgressBarTracker, {
			scaleX: 0,
		})

		this.updateProgressEndScrollTop()
		window.addEventListener('resize', this.bndOnResize)
		this.scrollElement.addEventListener('scroll', this.bndOnScroll)
	}
	updateProgressEndScrollTop() {
		if (!this.progressEndEl) {
			this.progressEndScrollTop = null
			return
		}

		const targetRect = this.progressEndEl.getBoundingClientRect()

		if (this.scrollElement === window) {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop
			this.progressEndScrollTop = targetRect.top + scrollTop
		} else {
			const containerRect = this.scrollTarget.getBoundingClientRect()
			this.progressEndScrollTop = targetRect.top - containerRect.top + this.scrollTarget.scrollTop
		}
	}

	onScroll(ev) {
		let scrollTop, maxScroll

		if (this.scrollElement === window) {
			// Browser scrollbar mode
			scrollTop = window.pageYOffset || document.documentElement.scrollTop
			maxScroll = document.documentElement.scrollHeight - window.innerHeight
		} else {
			// Custom scroll element mode
			scrollTop = this.scrollTarget.scrollTop
			maxScroll = this.scrollTarget.scrollHeight - this.scrollTarget.clientHeight
		}

		if (this.progressEndScrollTop === null) {
			// no custom end
		} else {
			maxScroll = Math.max(1, this.progressEndScrollTop)
		}

		const progress = Math.max(0, Math.min(1, scrollTop / maxScroll))

		gsap.to(this.elProgressBarTracker, {
			scaleX: progress,
			duration: 0.2,
			overwrite: 'auto',
		})
	}

	destroy() {
		window.removeEventListener('resize', this.bndOnResize)
		this.scrollElement.removeEventListener('scroll', this.bndOnScroll)
	}
}

class NavIsland {
	constructor(element) {
		this.element = element
		this.elPanel = element.querySelector('.nav-island')
		// The scrollable region inside the island. The panel itself has
		// overflow:hidden, so the body-scroll-lock must allowlist this element
		// (not the panel) or it cancels the touchmove and touch scrolling breaks.
		this.elBody = this.elPanel.querySelector('.nav-island__body')
		this.elBg = element.querySelector('.main-nav__bg')
		this.elToggle = element.querySelector('.js-toggle')
		this.isExpanded = false
		this.bndToggle = this.toggle.bind(this)
		this.elToggle.addEventListener('click', this.bndToggle)
	}
	toggle() {
		if (this.isExpanded) {
			this.collapse()
		} else {
			this.expand()
		}
	}
	expand() {
		this.isExpanded = true
		this.elPanel.classList.add('is-expanded')

		gsap.fromTo(
			this.elBg,
			{ autoAlpha: 0, display: 'block' },
			{
				autoAlpha: 1,
				duration: 0.2,
				delay: 0,
				ease: 'Power2.easeOut',
			},
		)

		this.elOverlayPrimary = this.elPanel.querySelector('.island-overlay__primary-nav')
		this.elNavItems = Array.from(this.elOverlayPrimary.querySelectorAll('.island-overlay__primary-nav .nav-item'))
		this.elOverlaySecondary = this.elPanel.querySelector('.island-overlay__secondary-nav')

		gsap.set([this.elOverlayPrimary, this.elOverlaySecondary], { opacity: 0 })
		gsap.fromTo([this.elOverlayPrimary], { autoAlpha: 0, y: 0 }, { autoAlpha: 1, y: 0, duration: 0.5, ease: 'Power2.easeOut', stagger: 0.5 })

		gsap.fromTo(
			this.elNavItems,
			{ autoAlpha: 0, y: 20 },
			{
				autoAlpha: 1,
				y: 0,
				duration: 0.4,
				ease: 'Power2.easeOut',
				stagger: 0.05,
			},
		)

		gsap.fromTo(
			this.elOverlaySecondary,
			{ opacity: 0 },
			{
				opacity: 1,
				duration: 0.8,
				delay: 0.3,
				ease: 'Power2.easeOut',
			},
		)

		window.app.browser.disableScroll(this.elBody || this.elPanel)
	}
	collapse() {
		this.isExpanded = false
		this.elPanel.classList.remove('is-expanded')
		gsap.to(this.elBg, {
			autoAlpha: 0,
			duration: 0.5,
			ease: 'Power3.easeOut',
			onComplete: () => {
				gsap.set(this.elBg, { display: 'none' })
			},
		})

		window.app.browser.enableScroll(this.elPanel)
	}
	destroy() {}
}

/** Language toggle
 *
 * The pill is a single link to the other language. On click we don't prevent
 * navigation — we just flip the active index so the knob slides to the other
 * side during the page transition.
 */
class LanguageToggle {
	constructor(element) {
		this.element = element
		this.bndOnClick = this.onClick.bind(this)
		this.element.addEventListener('click', this.bndOnClick)
	}
	onClick(e) {
		// Let modified clicks (new tab / download) pass through untouched.
		if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return
		// Commit the swap: pin the knob to the target so it can't animate back if
		// the pointer leaves before Swup navigates. is-navigating disables the
		// hover rule so the committed position wins (no inversion/jump).
		this.element.classList.add('is-navigating')
		const current = Number(this.element.dataset.active || 0)
		this.element.dataset.active = current === 0 ? 1 : 0
	}
	destroy() {
		this.element.removeEventListener('click', this.bndOnClick)
	}
}

//
export default class extends Component {
	prepare() {
		this.navIsland = new NavIsland(this.element)

		const elLanguageToggle = this.element.querySelector('.js-language-toggle')
		if (elLanguageToggle) {
			this.languageToggle = new LanguageToggle(elLanguageToggle)
		}
		// console.log('Initializing MainNav component')
		// // -- Overlay ------------------------------------------ //
		// this.overlayHandler = new OverlayHandler(this.element)
		// // -- Sticky Header ------------------------------------ //
		this.stickyHeader = new StickyHeader({
			element: this.element,
			offset: 20,
			showAtBottom: false,
			thresholds: { reposition: 100 },
			on: {
				stateChange: (newState, oldState, ctx) => {
					// console.log(`Header state: ${oldState} → ${newState}`)
					// document.body.classList.remove(`header-state-${oldState}`)
					// document.body.classList.add(`header-state-${newState}`)
				},
				'state:top': (ctx) => {},
				'state:hidden': (ctx) => {
					// this.overlayHandler.hide()
				},
				'threshold:compact': ({ crossed }) => {},
				'threshold:cta': ({ crossed }) => {},
			},
		})

		this.bndOnSwipNavSelfClick = this.onSwupNavSelfClick.bind(this)
		EventBus.on(Events.SWUP_LINK_SELF, this.bndOnSwipNavSelfClick)

		// The configurator hides the nav while in its focused (mobile) mode so it
		// can't overlap the configurator scrolled flush into the viewport. Freeze the
		// sticky header meanwhile: releasing the scroll lock on close jumps the page
		// back to its stored Y, which the header would otherwise read as a scroll-down
		// and hide itself right as it reappears. unfreeze() re-syncs the baseline.
		this.bndOnConfiguratorActive = ({ active }) => {
			this.element.classList.toggle('is-hidden', active)
			if (active) {
				this.stickyHeader?.freeze()
			} else {
				this.stickyHeader?.unfreeze()
			}
		}
		EventBus.on(Events.CONFIGURATOR_ACTIVE_CHANGE, this.bndOnConfiguratorActive)
		// this.stickyHeader.on('hide', (ctx) => console.log('Header hidden'))
		// this.stickyHeader.addThreshold('cta', 1200)
		// // -- Header Color --------------------------------------- //
		// this.headerColor = new HeaderColor(this.element, {
		// 	target: document.body,
		// 	themeSelector: '.page-section[data-theme]',
		// 	on: {
		// 		themeChange: (newTheme, oldTheme) => {
		// 			console.log(`Nav theme: ${oldTheme} → ${newTheme}`)
		// 		},
		// 		tintChange: (newTint, oldTint) => {
		// 			console.log(`Nav tint: ${oldTint} → ${newTint}`)
		// 		},
		// 	},
		// })
		// // -- Progress Tracker ----------------------------------- //
		// if (this.element.hasAttribute('data-track-progress')) {
		// 	this.progressTracker = new ProgressTracker({
		// 		element: this.element.querySelector('.nav-bar__progress'),
		// 		elProgressTracker: this.element.querySelector('.js-progress-tracker'),
		// 	})
		// }
		// // -- Nav Behaviour --- //
		// this.bndHideOverlay = this.overlayHandler.hide.bind(this.overlayHandler)
		// document.addEventListener('swup:link:self', this.bndHideOverlay)
	}

	mount() {}

	unmount() {
		if (this.navIsland) {
			this.navIsland.destroy()
		}

		if (this.languageToggle) {
			this.languageToggle.destroy()
		}

		if (this.stickyHeader) {
			this.stickyHeader.destroy()
		}

		EventBus.off(Events.SWUP_LINK_SELF, this.bndOnSwipNavSelfClick)
		EventBus.off(Events.CONFIGURATOR_ACTIVE_CHANGE, this.bndOnConfiguratorActive)
		// if (this.overlayHandler) {
		// 	this.overlayHandler.destroy()
		// }
		// if (this.stickyHeader) {
		// 	this.stickyHeader.destroy()
		// }
		// if (this.headerColor) {
		// 	this.headerColor.destroy()
		// }
		// if (this.progressTracker) {
		// 	this.progressTracker.destroy()
		// }
		// document.removeEventListener('swup:link:self', this.bndHideOverlay)
	}

	onSwupNavSelfClick(visit) {
		if (this.navIsland) {
			this.navIsland.collapse()
		}
	}
	onNavShapeClick(e) {
		// if (this.overlayMenu.isVisible) return
		// this.overlayMenu.show()
	}
}
